/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Warehouse Page: https://www.creative-tim.com/warehouse/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
    Alert,
    Button,
    Card,
    CardHeader,
    Col,
    FormGroup,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    CardFooter,
    Pagination,
    PaginationItem,
    PaginationLink,
    Container,
    Row,
} from "reactstrap";
// core components
import Warehouses from "components/Tables/Warehouse.js";
import Header from "components/Headers/WarehouseHeader.js";
import WarehouseDataService from "../../services/WarehouseDataService";
import WarehouseModal from "components/Modals/Warehouse";

class List extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultModal: false,
            warehouses: [],
            perPage: 10,
            currentPage: 1,
            currentWarehouse: {},
            searchId: 'nama'
        };
        this.warehouseDataService = new WarehouseDataService();
    }

    toggleWarehouseModal = (state, formType, warehouse) => {
        this.setState({
            [state]: !this.state[state],
            formType: formType,
            currentWarehouse: {
                ...warehouse,
            },
        });
    };

    componentDidMount() {
        this.fetchData()
    }

    handleSearch = (e) => {
        const keyword = e.target.value;
        this.setState({
            currentPage: keyword !== undefined && keyword !== '' ? 1 : this.state.currentPage,
            keyword: keyword,
        }, () => {
            this.fetchData(keyword);
        });
    }

    fetchData(keyword) {
        this.warehouseDataService.getList(this.state.currentPage, this.state.perPage, keyword)
            .then((data) => {
                return {
                    warehouses: data.data.warehouse_list !== null && data.data.errorMessage === undefined ? data.data.warehouse_list : [],
                    totalPages: data.data.total_data < this.state.perPage ? 1 : Math.ceil(data.data.total_data / this.state.perPage),
                    errorMessage: data.data?.errorMessage,
                    needRelogin: data.data?.needRelogin,
                }
            })
            .then(res => this.setState(res));
        setTimeout(() => {
            this.setState({ errorMessage: undefined })
        }, 5000);
    }

    handlePageClick = (e) => {
        const selectedPage = e;

        this.setState({
            currentPage: selectedPage,
        }, () => {
            this.fetchData(this.state.keyword)
        });
    }

    handleNextPageClick() {
        this.handlePageClick(this.state.currentPage + 1)
    }

    handlePreviousPageClick() {
        this.handlePageClick(this.state.currentPage - 1)
    }

    setSuccessMessage = (message) => {
        this.setState({ successMessage: message })
    }

    render() {
        const pageNumbers = [];
        for (var index = 1; index <= this.state.totalPages; index++) {
            pageNumbers.push(index)
        }

        const MAX_PAGES_DISPLAYED = 10; // Define the maximum number of page numbers to display at once
        const { currentPage, totalPages } = this.state;

        // Calculate the range of page numbers to display
        const startPage = Math.max(currentPage - Math.floor(MAX_PAGES_DISPLAYED / 2), 1);
        const endPage = Math.min(startPage + MAX_PAGES_DISPLAYED - 1, totalPages);

        // Include the minimum and maximum page numbers
        const minPage = 1;
        const maxPage = totalPages;

        const pageNumbersToDisplay = [];

        // Add the minimum page number if it's not in the range
        if (minPage < startPage) {
            pageNumbersToDisplay.push(minPage);
        }

        // Add ellipsis if there's a gap between the minimum page and the start of the range
        if (startPage > minPage) {
            pageNumbersToDisplay.push('...');
        }

        // Add the page numbers within the range
        for (let i = startPage; i <= endPage; i++) {
            pageNumbersToDisplay.push(i);
        }

        // Add ellipsis if there's a gap between the range and the maximum page
        if (endPage < maxPage) {
            pageNumbersToDisplay.push('...');
        }

        // Add the maximum page number if it's not in the range
        if (maxPage > endPage) {
            pageNumbersToDisplay.push(maxPage);
        }

        const renderPageNumbers =
            (
                <div>
                    <ul className="pagination">
                        {pageNumbersToDisplay.map(number => (
                            <PaginationItem key={number} className={currentPage === number ? "active" : ""}>
                                {number === '...' ? (
                                    <PaginationLink disabled>{number}</PaginationLink>
                                ) : (
                                    <PaginationLink onClick={() => this.handlePageClick(number)}>
                                        {number}
                                    </PaginationLink>
                                )}
                            </PaginationItem>
                        ))}
                    </ul>
                </div>
            );

        return (
            <>
                <Header />
                {/* Page content */}
                <Container className="mt--7" fluid>
                    {/* Table */}
                    <Row>
                        <div className="col">
                            <Card className="shadow">
                                <CardHeader className="border-0">
                                    <Row className="align-items-center">
                                        <Col xs="8">
                                            <h3 className="mb-0">Daftar warehouse</h3>
                                        </Col>
                                        <Col className="text-right" xs="4">
                                            <Button
                                                color="primary"
                                                onClick={() => this.toggleWarehouseModal("formWarehouseModal", "add")}
                                                size="sm"
                                            >
                                                Tambah baru
                                            </Button>
                                            <WarehouseModal
                                                toggleModal={() => this.toggleWarehouseModal("formWarehouseModal")}
                                                formModal={this.state.formWarehouseModal}
                                                formType={this.state.formType}
                                                currentWarehouse={this.state.currentWarehouse}
                                                setSuccessMessage={this.setSuccessMessage}
                                                fetchData={this.fetchData.bind(this)}
                                            />
                                        </Col>
                                        {this.state.successMessage && (
                                            <Col xs="12" className="mt-5">
                                                <Alert color="success">
                                                    {this.state.successMessage}
                                                </Alert>
                                            </Col>
                                        )}
                                        {this.state.errorMessage && (
                                            <Col xs="12" className="mt-5">
                                                <Alert color="danger">
                                                    {this.state.errorMessage}
                                                </Alert>
                                            </Col>
                                        )}
                                    </Row>
                                    <Row>
                                        <Col xs="4" className="mt-3 align-items-right">
                                            <FormGroup>
                                                <InputGroup className="input-group-alternative mb-4">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="ni ni-zoom-split-in" />
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input
                                                        className="form-control-alternative"
                                                        placeholder="Search warehouse"
                                                        onChange={(e) => this.handleSearch(e)}
                                                        type="text"
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <Warehouses
                                    warehouses={this.state.warehouses}
                                    toggleModal={this.toggleWarehouseModal}
                                    formModal={this.state.formModal}
                                    formType={this.state.formType}
                                    setSuccessMessage={this.setSuccessMessage}
                                    fetchData={this.fetchData.bind(this)}
                                />
                                <CardFooter className="py-4">
                                    <nav aria-label="...">
                                        <Pagination
                                            className="pagination pagination-lg justify-content-end mb-0"
                                            listClassName="justify-content-end mb-0"
                                        >
                                            <PaginationItem className={this.state.currentPage === 1 && "disabled"}>
                                                <PaginationLink
                                                    onClick={() => this.handlePreviousPageClick()}
                                                    tabIndex="-1"
                                                >
                                                    <i className="fas fa-angle-left" />
                                                    <span className="sr-only">Previous</span>
                                                </PaginationLink>
                                            </PaginationItem>
                                            {renderPageNumbers}
                                            <PaginationItem className={this.state.currentPage === this.state.totalPages && "disabled"}>
                                                <PaginationLink
                                                    onClick={() => this.handleNextPageClick()}
                                                >
                                                    <i className="fas fa-angle-right" />
                                                    <span className="sr-only">Next</span>
                                                </PaginationLink>
                                            </PaginationItem>
                                        </Pagination>
                                    </nav>
                                </CardFooter>
                            </Card>
                        </div>
                    </Row>
                </Container>
            </>
        );
    }
}

export default List;
